import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchDataAPI } from '../../helpers/fetchDataAPI';
import { URL_BASE_API } from '../../services/glogal';
import { store } from '../store'


export const load = createAsyncThunk(
    'userAdmin/load',
    async (data) => {
        const url = `${URL_BASE_API}/api/useradmin/getlistuseradmin`;
        const token = store.getState().userLogged.token;
        // const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        
        const rsp = fetchDataAPI(
            url,
            {
                field01: data.userId, 
                field02: data.name,
                field03: data.email,
                field04: data.active,
                field05: data.roleId,
                lang: language
            },
            config
        );
        
        return rsp;
    }
);



export const save = createAsyncThunk(
    'userAdmin/save',
    async (data) => {
        const url = `${URL_BASE_API}/api/useradmin/saveuseradmin`;
        const token = store.getState().userLogged.token;
        // const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;
        
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        
        const rsp = fetchDataAPI(
            url,
            {
                field01: data.userId,
                field02: data.name,
                field03: data.email,
                field04: data.isactive,
                field05: data.roleId,
                lang: language
            }, 
            config
        );
        
        return rsp;
    }
);



export const remove = createAsyncThunk(
    'userAdmin/remove',
    async (data) => {
        const url = `${URL_BASE_API}/api/useradmin/deleteuseradmin`;
        const token = store.getState().userLogged.token;
        const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
    
        const rsp = fetchDataAPI(
            url,
            {
                field01: data,          //user to remove 
                field02: userId,        //currently user logged
                lang: language
            }, 
            config
        );
        
        return rsp;
    }
);



export const setstars = createAsyncThunk(
    'userAdmin/setstars',
    async (data) => {
        const url = `${URL_BASE_API}/api/profile/setstars`;
        const token = store.getState().userLogged.token;
        const userId = store.getState().userLogged.userLogged.userId;
        const language = store.getState().configuration.language;

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
    
        const rsp = fetchDataAPI(
            url,
            {
                field01: userId,
                field02: data.evaluatedUserId,
                field03: data.grade,
                lang: language
            }, 
            config
        );
        
        return rsp;
    }
);
